import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useAppDispatch, useAppSelector } from '@/store/store-hooks'
import { setSessionEndedModalVisible } from '@/store/slices/ui-state.slice'
import { Modal, ModalContent } from '@/components/modal/Modal'
import { ModalFooterWithActions } from '@/components/modal/ModalFooterWithActions'

/**
 * Session Ended Modal
 * Logging out revokes every session, but other tabs and devices keep their cached ID token until
 * it expires and see API errors meanwhile. Firebase signs out locally once a forced refresh is
 * rejected: on load, on navigation after five minutes, or at the SDK's own background refresh.
 * AuthContextProvider opens the modal when that sign-out did not come from this tab.
 */
export default function SessionEndedModal() {
  const open = useAppSelector((state) => state.uiState.sessionEndedModalVisible)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (open) navigate('/dashboard')
  }, [open, navigate])

  const close = () => dispatch(setSessionEndedModalVisible(false))

  return (
    <Modal open={open} onOpenChange={(nextOpen) => !nextOpen && close()}>
      <ModalContent
        title="You've been signed out"
        subtitle="You signed out of Paxton on another device or your session ended. Sign in again to continue."
        width="sm"
        height="max-sm"
        footer={<ModalFooterWithActions primaryAction={{ label: 'OK', onClick: close }} />}
      />
    </Modal>
  )
}
